import {Component} from '@angular/core';

import {GeneralListComponent} from '../../general/list/generalList.component';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {MessageService} from '../../../../shared/message.service';
import {UserRightGroup} from '../../../interfaces/userRightGroup';
import {UserRightGroupService} from '../../../services/user-group-right.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'qm-user-right-groups',
  templateUrl: '../../general/list/generalList.component.html',
  styleUrls: ['../../general/list/generalList.component.css']
})
export class UserRightGroupListComponent extends GeneralListComponent<UserRightGroup> {

  constructor(
    service: UserRightGroupService,
    location: Location,
    router: Router,
    messagesService: MessageService,
    modalService: NgbModal,
    route: ActivatedRoute) {
    super(
      service,
      router,
      messagesService,
      route,
      modalService,
      {
        entityNameSingular: 'group right',
        entityNamePlural: 'group rights',
        formUrl: 'groupright',
        listUrl: 'grouprights',
        generalFormMetaName: 'user-right-group',
        tableColumns: [
          {id: 'id', title: 'Id'},
          {id: 'type', title: 'Type'},
          {id: 'groupId', title: 'group'},
          {id: 'userRightId', title: 'user right'},
          ]
      },
    );
  }
}
